define('rebrush/components/review/list',[
    'jquery',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'gigaset/spinner'
], function(
    $,
    Component,
    BEM,
    Spinner
) {
    return Component.create({
        block:			    null,
        pagerLinks:         null,
        ajaxControllerUrl:  null,
        productId:          null,

        $init: function() {
            var self = this;
            this.block = BEM.block('review-list');

            this.block.on('click', '.b_pager li:not(.active)>a', function(e) {
                var currentUrl = $(this).prop('href');

                e.preventDefault();

                try {
                    var dataBlock = self.block.find('[data-ajax-reviews-url]');
                    self.ajaxControllerUrl = dataBlock.data('ajax-reviews-url');
                    self.productId = dataBlock.data('ajax-reviews-product-id');

                    var listWrapper = self.block.find('.' + BEM.buildElementClassname('review-list','list-wrapper')),
                        listListSelector = '.' + BEM.buildElementClassname('review-list', 'list'),
                        paginationSelector = '.js-review-pagination',
                        ajaxUrl = self.ajaxControllerUrl + 'product/' + self.productId  + '/p/' + self.parseQueryString('p', currentUrl);

                    Spinner['add'](listWrapper);
                    $.ajax(ajaxUrl, {
                        success: function(res) {
                            if (typeof res.reviews !== 'undefined') {
                                var reviewsBlock = $(res.reviews);

                                self.block.find(listListSelector).html(reviewsBlock.find(listListSelector).html());
                                self.block.find(paginationSelector).html(reviewsBlock.find(paginationSelector).html());

                                self.block.parents('.' + BEM.buildElementClassname('tabs','tab-content')).trigger('gigaset.content.change');
                                self.scrollIntoViewIfNeeded(self.block);
                                Spinner['remove'](listWrapper);
                            } else {
                                self.fallback(currentUrl);
                            }
                        },
                        error: function() {
                            self.fallback(currentUrl);
                        },
                        cache: true
                    });
                    return false;
                } catch (e) {
                    self.fallback(currentUrl);
                }
            });
        },

        parseQueryString: function( name, url ) {
            if (!url) url = location.href;
            name = name.replace(/[\[]/,'\\\[').replace(/[\]]/,'\\\]');
            var regexS = '[\\?&]'+name+'=([^&#]*)';
            var regex = new RegExp( regexS );
            var results = regex.exec( url );
            return results == null ? null : results[1];
        },

        scrollIntoViewIfNeeded: function($target) {
            if ($target.offset()) {
                if ($target.offset().top < $(window).scrollTop()){
                    //scroll up
                    $('html,body').animate({scrollTop: $target.offset().top});
                }
                else if ($target.offset().top + $target.outerHeight() >
                    $(window).scrollTop() + (
                        window.innerHeight || document.documentElement.clientHeight
                    )) {
                    //scroll down
                    $('html,body').animate({scrollTop: $target.offset().top -
                            (window.innerHeight || document.documentElement.clientHeight)
                            + $target.outerHeight()}
                    );
                }
            }
        },

        fallback: function(url) {
            location.href = url;
        }
    });
});
